import { InjectionToken, Provider } from '@angular/core';
import { tuiCreateToken } from '@taiga-ui/cdk';
import { DateTime } from 'luxon';

/**
 * The time zone used for date/time formatting (when an output ISO-8601 string is provided to the user/system).
 */
export const ION_TARGET_TIME_ZONE: InjectionToken<string> = tuiCreateToken(DateTime.local().zone.name);

/**
 * Creates an Angular provider that overrides the target time zone token.
 *
 * This allows configuring the application-wide time zone for formatting
 * and conversion operations (e.g., when using Luxon to output ISO strings).
 *
 * @param useValue - An IANA time zone string (e.g., 'Europe/Berlin', 'UTC').
 * @returns An Angular provider for `ION_TARGET_TIME_ZONE`.
 */
export function currentTargetTimeZoneProvider(useValue: string): Provider {
  return {
    provide: ION_TARGET_TIME_ZONE,
    useValue,
  };
}
